import React from 'react'

const HelpAndSupport = () => {
  return (
    <div>HelpAndSupport Page</div>
  )
}

export default HelpAndSupport;